import { injectIntl, IntlShape } from 'react-intl';
import { useState } from 'react';
import {
  RegulationHeader,
  ContainerRegulation,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import RegulationForm from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationForm';
import SideRegulationRecap from 'containers/CourtManagerLegalProceedings/Provision/Regulation/SideRecap/SideRegulationRecap';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import { AssignedLawyer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { ClaimRecapType } from 'typings/claimTypes';

export interface RegulationContainerProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  listings: Listings;
  judgementOnMeritsByVictims: any;
  requestGetJudgementOnMeritsByVictims: Function;
  judgementOnMeritsByVehicles: any;
  requestGetJudgementOnMeritsByVehicles: Function;
  requestCreateCorpoEncryptedDocument: Function;
  requestCreateCorporealRegulation: Function;
  requestCreateMaterialRegulation: Function;
  requestCreateAdditionalWarrentiesRegulation: Function;
  corporealEncryptedDocuments: any;
  requestMaterialEncryptedDocument: Function;
  materialEncryptedDocuments: any;
  requestGetAssignedLawyers: Function;
  assignedLawyers: AssignedLawyer[];
  requestSagisClaimInfo: Function;
  requestGetDahirAmount: Function;
  requestGetDahirAmountCorpo: Function;
  dahirAmount: any;
  dahirAmountsCorpo: any;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  uploadedDocument: IUploadedDocument;
  requestValidateProvisionIntervenant: Function;
  createdRegulations: any;
  requestCreateSummarySheetRegulation: Function;
  uploadDocumentRegulation: Function;
  corpoRegulations: any;
  policyInfo: any;
  requestValidateProvision: Function;
  isBasicManagementRegulation?: boolean;
}

export const RegulationContainer: React.FC<RegulationContainerProps> = ({
  sagisClaim,
  listings,
  claimRecap,
  ...props
}): JSX.Element => {
  const [riskRecap, setRiskRecap] = useState<any>([]);
  const [showSideRecap, setShowSideRecap] = useState<any>(true);
  const [substituteDocumentNature, setSubstituteDocumentNature] = useState(
    [] as SagisConfig[],
  );
  const [showRegulationJudgement, setShowRegulationJudgement] = useState(false);
  const [height, setHeight] = useState(0);

  return (
    <ContainerRegulation>
      <RegulationHeader showSideRecap={showSideRecap}>
        <RegulationForm
          sagisClaim={{ ...sagisClaim }}
          claimRecap={claimRecap}
          setRiskRecap={setRiskRecap}
          riskRecap={riskRecap}
          listings={listings}
          judgementOnMeritsByVictims={props.judgementOnMeritsByVictims}
          requestGetJudgementOnMeritsByVictims={
            props.requestGetJudgementOnMeritsByVictims
          }
          judgementOnMeritsByVehicles={props.judgementOnMeritsByVehicles}
          requestGetJudgementOnMeritsByVehicles={
            props.requestGetJudgementOnMeritsByVehicles
          }
          requestCreateCorpoEncryptedDocument={
            props.requestCreateCorpoEncryptedDocument
          }
          corporealEncryptedDocuments={props.corporealEncryptedDocuments}
          setShowSideRecap={setShowSideRecap}
          showSideRecap={showSideRecap}
          setSubstituteDocumentNature={setSubstituteDocumentNature}
          substituteDocumentNature={substituteDocumentNature}
          setShowRegulationJudgement={setShowRegulationJudgement}
          requestCreateCorporealRegulation={
            props.requestCreateCorporealRegulation
          }
          requestCreateMaterialRegulation={
            props.requestCreateMaterialRegulation
          }
          requestCreateAdditionalWarrentiesRegulation={
            props.requestCreateAdditionalWarrentiesRegulation
          }
          setHeight={setHeight}
          requestMaterialEncryptedDocument={
            props.requestMaterialEncryptedDocument
          }
          materialEncryptedDocuments={props.materialEncryptedDocuments}
          requestGetAssignedLawyers={props.requestGetAssignedLawyers}
          assignedLawyers={props.assignedLawyers}
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          requestGetDahirAmount={props.requestGetDahirAmount}
          requestGetDahirAmountCorpo={props.requestGetDahirAmountCorpo}
          dahirAmountsCorpo={props.dahirAmountsCorpo}
          dahirAmount={props.dahirAmount}
          uploadDocument={props.uploadDocument}
          resetUploadDocumentStore={props.resetUploadDocumentStore}
          uploadedDocument={props.uploadedDocument}
          requestValidateProvisionIntervenant={
            props.requestValidateProvisionIntervenant
          }
          createdRegulations={props.createdRegulations}
          requestCreateSummarySheetRegulation={
            props.requestCreateSummarySheetRegulation
          }
          corpoRegulations={props.corpoRegulations}
          uploadDocumentRegulation={props.uploadDocumentRegulation}
          policyInfo={props.policyInfo}
          requestValidateProvision={props.requestValidateProvision}
          lastSagisClaim={sagisClaim}
          isBasicManagementRegulation={props.isBasicManagementRegulation}
        />
        {showSideRecap && (
          <SideRegulationRecap
            height={height}
            sagisClaim={{ ...sagisClaim }}
            claimRecap={claimRecap}
            riskRecap={riskRecap}
            substituteDocumentNature={substituteDocumentNature}
            listings={listings}
            showRegulationJudgement={showRegulationJudgement}
            isBasicManagementRegulation={props.isBasicManagementRegulation}
          />
        )}
      </RegulationHeader>
    </ContainerRegulation>
  );
};

export default injectIntl(RegulationContainer);
